import axios from 'axios';

// Configure axios to send cookies with every request
axios.defaults.withCredentials = true;

// Add request interceptor to attach Bearer token and credentials
axios.interceptors.request.use(
  (config) => {
    // Ensure credentials are included (for cookie-based auth)
    config.withCredentials = true;
    
    // Attach Bearer token if available (for token-based auth)
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't hard-redirect on transient 401s – let the app's auth flow decide.
      // Only signal that auth may have changed; ProtectedRoute will redirect if needed.
      const currentPath = window.location.pathname;
      if (currentPath !== '/signup' && currentPath !== '/') {
        window.dispatchEvent(new Event('authChanged'));
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
